var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"icon",attrs:{"src":_vm.src},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }